import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'
import styled from 'styled-components'
import { grey300 } from 'material-ui/styles/colors'

const RoundButton = muiThemeable()(
  styled(
    ({
      className,
      onClick,
    }) => {
      return (
        <button className={className} onClick={onClick}>
          <i className="fa fa-plus" />
        </button>
      )
    }
  )`
    border: none;
    border-radius: 20px;
    background-color: ${grey300};
    transition: 0.3s;
    width: 100px;
    margin: 0 auto;
    display: block;
    
    :hover {
      background-color: ${
        ({ muiTheme: { palette: { accent1Color }}}) => accent1Color
      };
      color: white;
    }
  `
)

RoundButton.propTypes = {}
RoundButton.defaultProps = {}

export default RoundButton



// WEBPACK FOOTER //
// ./src/components/Button/RoundButton.js